module.exports = __webpack_public_path__ + "static/media/clients-03.bbaa54a0.svg";